var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"role":"img","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('title',[_vm._v("Facebook Gaming")]),_c('path',{attrs:{"d":"M0 0v24h15.67v-7.35H7.35v-9.3H24V0zm8.33 15.68h8.32V24H24V8.32H8.33Z","fill":_vm.fill_color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }